import Service from '@ember/service';
import { assert } from '@ember/debug';
import { computed, action } from '@ember/object';
import { reads } from '@ember/object/computed';
import { getOwner } from '@ember/application';
import Evented from '@ember/object/evented';
import { namespaceEngineRouteName } from '../utils/namespace-engine-route-name.js';
import { getRootOwner } from '../utils/root-owner.js';
import { resemblesURL } from '../utils/resembles-url.js';
import '@ember/application/instance';

function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
let EngineRouterService = (_dec = reads('externalRouter.rootURL'), _dec2 = reads('externalRouter.currentURL'), _dec3 = computed('_mountPoint.length', 'externalRouter.currentRouteName'), (_class = class EngineRouterService extends Service.extend(Evented) {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "rootURL", _descriptor, this);

    _initializerDefineProperty(this, "currentURL", _descriptor2, this);

    this._externalRoutes = getOwner(this)._externalRoutes; // eslint-disable-next-line ember/no-assignment-of-untracked-properties-used-in-tracking-contexts

    this._mountPoint = getOwner(this).mountPoint;
    this.rootApplication = getRootOwner(this);
    this.externalRouter.on('routeWillChange', this.onRouteWillChange);
    this.externalRouter.on('routeDidChange', this.onRouteDidChange);
  }

  willDestroy() {
    this.externalRouter.off('routeWillChange', this.onRouteWillChange);
    this.externalRouter.off('routeDidChange', this.onRouteDidChange);
    super.willDestroy();
  }

  onRouteWillChange(...args) {
    this.trigger('routeWillChange', ...args);
  }

  onRouteDidChange(...args) {
    this.trigger('routeDidChange', ...args);
  }

  get currentRouteName() {
    if (this.externalRouter.currentRouteName === this._mountPoint) {
      return 'application';
    }

    return this.externalRouter.currentRouteName.slice(this._mountPoint.length + 1);
  }

  get externalRouter() {
    return this.rootApplication.lookup('service:router');
  }

  getExternalRouteName(externalRouteName) {
    assert(`External route '${externalRouteName}' is unknown.`, externalRouteName in this._externalRoutes);
    return this._externalRoutes[externalRouteName];
  }

  transitionTo(routeName, ...args) {
    if (resemblesURL(routeName)) {
      return this.externalRouter.transitionTo(routeName);
    }

    return this.externalRouter.transitionTo(namespaceEngineRouteName(this._mountPoint, routeName), ...args);
  }

  transitionToExternal(routeName, ...args) {
    return this.externalRouter.transitionTo(this.getExternalRouteName(routeName), ...args);
  }

  replaceWith(routeName, ...args) {
    if (resemblesURL(routeName)) {
      return this.externalRouter.replaceWith(routeName);
    }

    return this.externalRouter.replaceWith(namespaceEngineRouteName(this._mountPoint, routeName), ...args);
  }

  replaceWithExternal(routeName, ...args) {
    return this.externalRouter.replaceWith(this.getExternalRouteName(routeName), ...args);
  }

  urlFor(routeName, ...args) {
    return this.externalRouter.urlFor(namespaceEngineRouteName(this._mountPoint, routeName), ...args);
  }

  urlForExternal(routeName, ...args) {
    return this.externalRouter.urlFor(this.getExternalRouteName(routeName), ...args);
  }

  isActive(routeName, ...args) {
    return this.externalRouter.isActive(namespaceEngineRouteName(this._mountPoint, routeName), ...args);
  }

  isActiveExternal(routeName, ...args) {
    return this.externalRouter.isActive(this.getExternalRouteName(routeName), ...args);
  }

}, (_applyDecoratedDescriptor(_class.prototype, "onRouteWillChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onRouteWillChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRouteDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onRouteDidChange"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "rootURL", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentURL", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currentRouteName", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "currentRouteName"), _class.prototype)), _class));

export { EngineRouterService as default };
